import { SidebarServiceService } from './../sidebar/service/sidebar-service.service';
import { Component, inject, OnInit } from '@angular/core';

import { Router, RouterLink } from '@angular/router';

import { AuthenticationService } from '../../authentication/services/authentification.service';
import { User_info_auth } from '../../authentication/models/user_info';
import { MatDialog } from '@angular/material/dialog';
import { ModalLogoutComponent } from './modal-logout/modal-logout.component';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [RouterLink, TitleCasePipe]
})
export class HeaderComponent implements OnInit {

  ngOnInit(): void {
  }
  currentUser: User_info_auth;

  constructor(
      private router: Router,
      private sb : SidebarServiceService,
      private authenticationService: AuthenticationService
  ) {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  readonly dialog = inject(MatDialog)

  openModalLogout(enterAnimationDuration : string, exitAnimationDuration : string) : void{
    this.sb.etat.next(false)
    this.dialog.open(ModalLogoutComponent, {
      width : '400px',
      height : '200px',
      enterAnimationDuration,
      exitAnimationDuration
    })
  }

  ngOnDestroy(): void {
    this.dialog.closeAll()
  }
//close sidebar
  closeSb(){
    this.sb.etat.next(false)
  }

}
